import { DTRelay } from '@expressive-analytics/dtrelay';
const $R = new DTRelay("Relay", {
  //url: "http://localhost:8887/",
  //url: process.env.REACT_APP_RELAY_URL,
  url: "https://relay2.assets.mu.hekademeia.org/",
  manifest: {
    "assets-api": {
      "Login": "authentication"
    },
    "assets-api-oauth": {
      "SecureUser": "user",
      "SecureHouse": "house",
      "SecureItem": "item",
      "SecureEvent": "event",
      "SecureSensation": "sensation"
    }
  }
});
$R.redirect_callback = (location) => {
  console.log(window.location.href);
  if (!window.location.href.match(/login/))
    window.location.href = location.replace(/login/, "login");
};
export default $R;